// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.code-box {\r\n    max-width: 90%;\n}\n.code {\r\n    text-align: left !important;\r\n    font-size: small;\n}\n.avatar {\r\n    height: 25px;\r\n    width: 25px;\r\n    border-radius: 50%;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
